define('core/extensions/helpers/partial',[
    'handlebars',
], function (
    Handlebars
) {
    'use strict';

    /*
     * Register partial via helper. It allows to have several partials at the same file.
     */
    return function (name, options) {
        Handlebars.registerPartial(name, options.fn);
    };
});

